// extracted by mini-css-extract-plugin
module.exports = {"container":"IppicaEmpty_container__8XtmY","withMarginRight":"IppicaEmpty_withMarginRight__2Q0da","icon":"IppicaEmpty_icon__vjo_c","text":"IppicaEmpty_text__MS_az"};